<template>
  <q-popover class="user-popover" :anchor="'bottom right'" :self="'top right'">
    <q-list item-separator link>
      <!-- Profile -->
      <q-item v-close-overlay exact :to="{ name: 'settings' }">
        <q-item-side>
          <q-icon name="person"/>
        </q-item-side>

        <q-item-main>
          <span>{{ $t('profile') }}</span>
        </q-item-main>
      </q-item>

      <!-- Companies -->
      <q-item
        v-close-overlay
        exact
        :disabled="!activeTeam"
        @click.native="handleTeamSettings"
      >
        <q-item-side>
          <q-icon name="settings"/>
        </q-item-side>

        <q-item-main>
          <span>{{ $t('team_setting') }}</span>
        </q-item-main>
      </q-item>

      <q-item-separator/>

      <q-item v-close-overlay @click.native="handleChangeTeam">
        <q-item-side>
          <q-icon name="swap_horiz"/>
        </q-item-side>

        <q-item-main>
          <span>{{ $t('change_team') }}</span>
        </q-item-main>
      </q-item>

      <q-item-separator/>

      <!-- Logout -->
      <q-item v-close-overlay @click.native="handleLogout" id="logout">
        <q-item-side>
          <q-icon name="power_settings_new"/>
        </q-item-side>

        <q-item-main>
          <span>{{ $t('logout') }}</span>
        </q-item-main>
      </q-item>
    </q-list>

    <team-switcher ref="teamSwitcher" :teams="teams" :active-team="activeTeam" @createTeam="handleCreateTeam"/>
  </q-popover>
</template>

<script>
  import TeamSwitcher from './TeamSwitcher.vue'
  import imageMixin from 'src/utils/mixins/image'
  import { mapActions } from 'vuex'

  export default {
    props: {
      teams: {
        type: Array,
        required: true
      },
      activeTeam: {
        type: Object,
        required: false
      }
    },

    methods: {
      ...mapActions(['logout']),

      handleLogout () {
        this.logout()
        this.$router.push('/login')
      },

      handleChangeTeam () {
        this.$refs.teamSwitcher.show()
      },

      handleCreateTeam () {
        this.$router.push({ name: 'new-team' })
      },

      handleTeamSettings () {
        this.$router.push({ name: 'team-settings', params: { teamId: this.activeTeam.id } })
      }
    },

    components: {
      TeamSwitcher
    },

    mixins: [
      imageMixin
    ]
  }
</script>
